$(document).ready(function(){

//-----------------search code---------------------------- 
  
$(".header__search .ul_inner_search .enter_list_search").click(function(){
      var search_val= $(this).attr("search_id");
  $('.header__search .ul_inner_search .enter_list_search').removeClass("active")
  $(this).addClass('active');
       $('.header__search #Search-In-Modal').val(search_val); 
        $( ".header__search button.search__button.field__button" ).trigger( "click" );

});

// header-search-add-class
$('.header__search').click(function(){
  $(this).parents('.header-part').toggleClass('search-active');
});

  
// ---------------size-guide-drawer------------------
  
 if($('.section-guide-care').length > 0){
   // Show popup when clicking on '.guide-content-blocks'
  $('.guide-content-blocks').click(function(){
     $('body').addClass('pop-show');
  $(this).parents('.guide-care-inner').find('.guide-drawer-blocks').addClass('show');
  });
   
  // Hide popup when clicking on '.cross-btn'
  $('.cross-btn').click(function(){
    $(this).parents('.guide-care-inner').find('.guide-drawer-blocks').removeClass('show');
       $('body').removeClass('pop-show');
  });
   
   // Hide popup when clicking anywhere on the body
  $('body').click(function(event){
    if(!$(event.target).closest('.guide-content-blocks').length && !$(event.target).closest('.cross-btn').length && !$(event.target).closest('.guide-drawer-blocks').length) {
      $('.guide-drawer-blocks').removeClass('show');
      $('body').removeClass('pop-show');
    }
  });
 }

 // ---------------Footer Accordions------------------
  
        $(".accordion-top").click(function () {
    if ($(".accordion-content").is(":visible")) {
      $(".accordion-content").slideUp();
      $(".accordion-top").removeClass("active-footer");
    }
    if ($(this).next(".accordion-content").is(":visible")) {
      $(this).next(".accordion-content").slideUp();
      $(this).removeClass("active-footer");
    } else {
      $(this).next(".accordion-content").slideDown();
      $(this).addClass("active-footer");
    }
  });

//  --------------------eye icon code----------------------
  
 $(document).on('click','#eye-icon, #eye-icons, #eyes-icon1', function(){
     if($(this).hasClass('eye-close')){
       $(this).removeClass('eye-close');
        $(this).addClass('eye-open');
          $('.customer-password').attr('type','text');
         }else{
          $(this).removeClass('eye-open');
          $(this).addClass('eye-close');  
          $('.customer-password').attr('type','password');
        }
    });
   $(document).on('click','#eyes-icon2', function(){
     if($(this).hasClass('eye-close')){
       $(this).removeClass('eye-close');
        $(this).addClass('eye-open');
          $('.customer-passwords').attr('type','text');
         }else{
          $(this).removeClass('eye-open');
          $(this).addClass('eye-close');  
          $('.customer-passwords').attr('type','password');
        }
    });
  
});

$(document).ready(function(){

// ------------PDP Custom Slider-----------------
  
$('.cstm-verticle-slider').slick({
  slidesToScroll: 1,
   slidesToShow: 2,
  arrows: false,
  dots: true,
  vertical: true,
  verticalSwiping: true,
  infinite: false,
   responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  }); 

  
// -----------------Create Account Neswletter-------------
  
    $('#accepts-marketing').click(function(){
    if($(this).is(":checked")) {
      $(this).parents('.accepts-marketing').addClass('checked');
    }
    else{
      $(this).parents('.accepts-marketing').removeClass('checked');
    }
  });

// -----------------cart-drawer slider----------------------
  
 $('.cart-collecton-wrap').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  prevArrow:'<button class="prev_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.784668 10.1372L9.84005 1.08182" stroke="#4D4D4D"/><path d="M0.980469 9.62891L10.3319 18.9804" stroke="#4D4D4D"/></svg></svg></button>',
  nextArrow:'<button class="next_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.3125 0.609619L10.3125 8.60962" stroke="#4D4D4D"/><path d="M1 18L10.3124 8.60962" stroke="#4D4D4D"/></svg></button>',
  infinite: true,
  arrows: true,
  centerMode: true,
centerPadding: '45px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
 $('.cart-collecton-wrap').slick('setPosition'); 
  
$(document).on("click", "div#wrappers_button_quantity .add-to-cart-button", function() {
setTimeout(function() {
  if($('.cart-collecton-wrap .cart-drawer__collection').length > 0){
   $('.cart-collecton-wrap').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      prevArrow:'<button class="prev_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.784668 10.1372L9.84005 1.08182" stroke="#4D4D4D"/><path d="M0.980469 9.62891L10.3319 18.9804" stroke="#4D4D4D"/></svg></svg></button>',
      nextArrow:'<button class="next_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.3125 0.609619L10.3125 8.60962" stroke="#4D4D4D"/><path d="M1 18L10.3124 8.60962" stroke="#4D4D4D"/></svg></button>',
      infinite: true,
      arrows: true,
      centerMode: true,
    centerPadding: '45px',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    }); 
  }
  else{
    
  }
    }, 4000);
});


$(document).on("click", ".cart-remove-button", function() {
setTimeout(function() {
  if($('.cart-collecton-wrap .cart-drawer__collection').length > 0){
 $('.cart-collecton-wrap').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  prevArrow:'<button class="prev_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.784668 10.1372L9.84005 1.08182" stroke="#4D4D4D"/><path d="M0.980469 9.62891L10.3319 18.9804" stroke="#4D4D4D"/></svg></svg></button>',
  nextArrow:'<button class="next_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.3125 0.609619L10.3125 8.60962" stroke="#4D4D4D"/><path d="M1 18L10.3124 8.60962" stroke="#4D4D4D"/></svg></button>',
  infinite: true,
  arrows: true,
  centerMode: true,
centerPadding: '45px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
  }
  else{
    
  }
    }, 2000);
  
});
  $(document).on("click", ".drawer__heading", function() {
setTimeout(function() {
  if($('.cart-collecton-wrap .cart-drawer__collection').length > 0){
 $('.cart-collecton-wrap').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  prevArrow:'<button class="prev_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.784668 10.1372L9.84005 1.08182" stroke="#4D4D4D"/><path d="M0.980469 9.62891L10.3319 18.9804" stroke="#4D4D4D"/></svg></svg></button>',
  nextArrow:'<button class="next_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.3125 0.609619L10.3125 8.60962" stroke="#4D4D4D"/><path d="M1 18L10.3124 8.60962" stroke="#4D4D4D"/></svg></button>',
  infinite: true,
  arrows: true,
  centerMode: true,
centerPadding: '45px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
  }
    }, 500);
  
});
    $(document).on("click", ".quantity-popover-container,.quantity-popover-container,.cart-item__quantity-wrapper.quantity-popover-wrapper input.quantity__input", function() {
        setTimeout(function() {
     $('.cart-collecton-wrap').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  prevArrow:'<button class="prev_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.784668 10.1372L9.84005 1.08182" stroke="#4D4D4D"/><path d="M0.980469 9.62891L10.3319 18.9804" stroke="#4D4D4D"/></svg></svg></button>',
  nextArrow:'<button class="next_arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.3125 0.609619L10.3125 8.60962" stroke="#4D4D4D"/><path d="M1 18L10.3124 8.60962" stroke="#4D4D4D"/></svg></button>',
  infinite: true,
  arrows: true,
  centerMode: true,
centerPadding: '45px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
        }, 1400);
    });

// --------------------Account Pages-------------------
  
if ($('.account-deatiled-info').length > 0) {
  
// ----------Order Pages Tabs-----------
  
   $(document).on('click', '.tab-top-part .tab-upper', function(){
     $('.tab-upper').removeClass('show');
    $(this).addClass('show');
     var tab_id = $(this).attr("tab_id");
     $(this).parents('.tab-wrapper').find('.tab-bottom-wrapper').find('.tab-bottom-part').removeClass('active');
      $(this).parents('.tab-wrapper').find('.tab-bottom-wrapper').find('.tab-bottom-part.'+tab_id).addClass('active');
    if($('.order-title').hasClass('show')){
       $('.new_title').text('ORDERS');
       }
   else{
       $('.new_title').text('MY ACCOUNT');
     }
  });
   
// -----------Account Page Popup------------------------
  
    $('.edit-btn').click(function(){
     if(this.hasAttribute("aria-expanded","false")) {
       $(this).attr("aria-expanded","true");
      $(this).parents('.data-addr-list').find('.edit_addr_form').addClass('popup-active').css('display','block');
       $('body').addClass('pop-show');
    }
      else{
        $(this).attr("aria-expanded","false");
      $(this).parents('.data-addr-list').find('.edit_addr_form').removeClass('popup-active').css('display','none');
        $('body').removeClass('pop-show');
      }
});
    $('.cross-buttons').click(function(){
      $('.edit-btn').parents('.data-addr-list').find('.edit_addr_form').removeClass('popup-active').css('display','none').attr("aria-expanded","false");
       $('body').removeClass('pop-show');
    });
      $('body').click(function(event){
   if(!$(event.target).closest('.cross-buttons').length && !$(event.target).closest('.edit_addr_form').length && !$(event.target).closest('.edit-btn').length) { 
      $('.edit-btn').parents('.data-addr-list').find('.edit_addr_form').removeClass('popup-active').css('display','none').attr("aria-expanded","false");
      $('body').removeClass('pop-show');
    }
  });
}

// -----------Show Order Tab on Click-------------------
  
   $('.order-det').click(function(){
   var get_link = $(this).find('a').attr('href');
    console.log(get_link, 'get_link');
        
    var window_url = window.location.href+ "account#order_id";
     console.log(window_url, 'link');
        
    if($(get_link === window_url)){
      console.log('dggg');
     $('#account_id').removeClass('show');
     $('#order_id').addClass('show');
     $('.address-part').removeClass('active');
     $('.orders-part').addClass('active');
       if($('.order-title').hasClass('show')){
       $('.new_title').text('ORDERS');
       }
   else{
       $('.new_title').text('MY ACCOUNT');
     }
    }
        
  });
  
  $(document).ready(function(){
    // Check if the URL contains a tab id
    var url = window.location.href;
    var tabIdIndex = url.indexOf("#");
    if (tabIdIndex !== -1) {
        // Extract the tab id from the URL
        var tabId = url.substring(tabIdIndex + 1);
        // Open the corresponding tab
        $("#" + tabId).addClass("show");
       $('#account_id').removeClass('show');
       if($('.order-title').hasClass('show')){
         $('.orders-part').addClass('active');
          $('#account_id').removeClass('show');
        $('.address-part').removeClass('active');
       
       $('.new_title').text('ORDERS');
       }
   else{
       $('.new_title').text('MY ACCOUNT');
     }
       
    }
});

});

// -----------------forget password-----------------------

  $(document).ready(function(){
       if(window.location.href == 'https://www.shop79e.com/account/login#recover') {
      $(".login-details-page").removeClass("visible").css('display','none');
      $("#forgot-password-section").addClass("visible").css('display','block');
    }
    if(window.location.href == 'https://www.shop79e.com/account/login?analytics_trace_id=3c3d0817-28ef-4d06-aa35-086e670052cd&error=login_required#recover'){
      $(".login-details-page").removeClass("visible").css('display','none');
      $("#forgot-password-section").addClass("visible").css('display','block');
    }
  });
  $(document).on( "click", '.forget-btn', function() {
    $(".login-details-page").removeClass("visible").css('display','none');
  $("#forgot-password-section").addClass("visible").css('display','block');
  });
  
  $(document).on( "click", '.back-login', function() {
     $(".login-details-page").addClass("visible").css('display','block');
    $("#forgot-password-section").removeClass("visible").css('display','none');
  });


// --------------Close sidebar when clicking outside--------------

$(document).on('click', function(e) {
    if (!$(e.target).closest('.sidebar').length) {
        $('.sidebar-toggle').removeClass('open');
    }
});

 $(document).ready(function(){
   
// -------------Sort on collection page---------------
   
    $(document).on('click', '.cstm-sort-icon', function() {
        $(this).parents('.facet-filters__field').find('.custom-select').toggleClass('active-sort');
    });

// ----------Hide popup when clicking anywhere on the body------------
   
  $(document).on('click', 'body', function(event) {
      if (!$(event.target).closest('.cstm-sort-icon').length) {
          $('.custom-select').removeClass('active-sort');
      }
   });
   
// ------------------variants-selection--------------------

  $(document).on('click', '.variant-opt-wrapper .cstm-radio', function(e) {
      $(this).parent('.input-var-color').addClass('show-var').siblings().removeClass('show-var');
      var var_img = $(this).parent('.input-var-color').attr('data-img');
      // var var_price = $(this).parent('.input-var-color').attr('data-price');
     var var_price = $(this).attr('data-price');
      var var_url = $(this).parent('.input-var-color').attr('data-url');

      var get_img = $(this).parents('.card--media').find('.card__inner').find('.card__media').find('.media').find('.image-container');
       get_img.attr('src',var_img);
      get_img.attr('srcset',var_img);
      // var get_price = $(this).parents('.card-information').find('.price').find('.price__container').find('.price__regular').find('.price-item--regular');
     var get_price = $(this).parents('.card__information').find('.price').find('.price__container').find('.price__regular').find('.price-item--regular');
      get_price.text(var_price);
      var get_img_url = $(this).parents('.card--media').find('.card__inner').find('a');
      get_img_url.attr('href',var_url);
      var get_price_url = $(this).parents('.card__information').find('a');
      get_price_url.attr('href',var_url);
    
    $('.cstm-radio-plus a').attr('href',var_url);
    }); 

// ---------------PDP page variant selection-----------
 var window_url = window.location.href;
    var url_splits = window_url.split("=");
   if(url_splits.length > 1) { 
          var new_url = url_splits[1]; 
        }
    
var select_imageContainer = '.selected-image';
var select_image = '#selectedImage';
var select_input = '.selectedInputt';
   
 $(".optionSelectedd").each(function(index) {
   var var_id =  $(this).find('.select_input').attr('data-id');
   var var_value = $(this).find('.variant-title-container').text();
   // var select_color = $(this).find('.optionSelected').attr('data-color');
   var class_space = var_value.split("(")[0].toLowerCase().replaceAll(' - ', '-');
   var var_class = class_space.trim().replaceAll(' ', '-');
    console.log(var_class,'var_class');
   
      if(new_url == var_id ){
        $(select_imageContainer).css('display','block');
        $(select_image).css('display','block');
         $(select_image).addClass(var_class);
        // $(select_image).attr('style',select_color);
        $(select_input).attr('placeholder',var_value);
        $(select_input).attr('data-ids',var_id);
     }
   else
      {
         $(select_image).removeClass(var_class);
      }
      //    // ---------
      //  var var_class = value.split("(")[0].toLowerCase().replaceAll(' - ', '-');
      //  var class_space = var_class.replaceAll(' ', '-').slice(0,-1);
      // selectedImage.classList.add(class_space);
      // console.log(class_space,'class_space');
 });
   
// ------------hulk app dropdown add/remove class

  $('body').click(function(event){
    if(!$(event.target).closest('.dropdown_swatch ').length) {
      $('.dropdown_swatch').removeClass('hulk-flex');
    }
  });

// -----------------cart-page------------------------------
  
  $('.cart-items-wrapper, .cart__footer-wrapper').wrapAll('<div class="wrapper_cart_page"></div>'); 
   
  // if($('.cart___items').hasClass('is-empty')){
  //   console.log('gfyy');
  //   $('.wrapper_cart_page').addClass('is-empty');
  // }

  // scroll top --------------
 $(window).scroll(function(){
  $(".scroll-top").click(function(){
  window.scrollTo({ top: 0, behavior: 'smooth' });
    $('.scroll-top').removeClass('scroll-on');
  });
 });
   
   $(window).scroll(function(){
    if($(this).scrollTop() > 300) {
    $('.scroll-top').addClass('scroll-on');
    } else {
    $('.scroll-top').removeClass('scroll-on');
    }
  });
     // $('a.load-more_btn.text-center.button').click(function(){
     //   $('.scroll-top').addClass('scroll-on');
     //   });
   
 });

